import { useState } from 'react';
import { toast } from 'react-toastify';

import Grid from '@material-ui/core/Grid';

import { Button, Dialog, Text } from 'components';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';

import { registerService } from '../../../../../services/register';

const validationSchema = Yup.object().shape({
  input_new_type: Yup.string().required('Tipo produto é obrigatório '),
});

export const DialogEdit = ({ openDialogEdit, handleCloseDialogEdit, line }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleUpdateTypeProduct = async (values) => {
    toast.info('Atualizando tipo produto');
    setIsLoading(true);
    try {
      const { data } = await registerService.updateTypeProduct({
        description: values.input_new_type,
        id: line.id,
      });
      toast.success('Tipo produto atualizada com sucesso');
      handleCloseDialogEdit();
      setIsLoading(false);
    } catch (error) {
      console.error(error.message);
      toast.error('Erro ao atualizar tipo produto');
      setIsLoading(false);
    }
  };

  return (
    <>
      <Dialog open={openDialogEdit}>
        <Dialog.Title onClose={handleCloseDialogEdit}>Atualizar</Dialog.Title>
        <Dialog.Content>
          <Formik
            initialValues={{ input_new_type: '' }}
            validationSchema={validationSchema}
            onSubmit={handleUpdateTypeProduct}
          >
            {(props) => (
              <Form>
                <Grid container spacing={3}>
                  <Grid item xs={12} lg={12}>
                    <Field
                      size='small'
                      loading={isLoading}
                      name='input_new_type'
                      variant='outlined'
                      fullWidth
                      label='Tipo produto'
                      component={Text}
                    />
                  </Grid>
                  <Grid item xs={3} md={3} lg={3}>
                    <Button type='submit' fullWidth loading={isLoading}>
                      Gravar
                    </Button>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Dialog.Content>
      </Dialog>
    </>
  );
};
